/* src/app/shared/components/loader/loader.scss */
.loader {
  position: fixed;
  z-index: 800;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader.page-loader {
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 999;
  background: none;
}
.loader.page-loader.no-menu {
  margin-top: 48px;
}
.loader.mini-loader {
  position: absolute;
}
.loader.mini-loader .loader-spinner {
  width: 24px;
  height: 24px;
  border-width: 2px;
}
.loader.mini-loader .loader-spinner::after {
  width: 24px;
  height: 24px;
  border-width: 2px;
}
.loader .loader-spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid var(--highlight_primary);
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  position: relative;
}
.loader .loader-spinner::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-bottom: 4px solid var(--highlight_secondary);
  border-left: 4px solid transparent;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=loader.css.map */
